import { push } from '@talend/router-bridge';

import { CadReduxAction, CustomAttributeDefinition } from '../../CAD.types';
import {
	OPENING_CUSTOM_ATTRIBUTE_DEFINITION_DELETE,
	CLOSING_CUSTOM_ATTRIBUTE_DEFINITION_DELETE,
	REMOVING_CUSTOM_ATTRIBUTE_DEFINITION,
	CLEAN_CUSTOM_ATTRIBUTE_DEFINITIONS,
	GET_CUSTOM_ATTRIBUTE_DEFINITIONS,
	RESET_CAD_LIST_DATA,
	SET_CAD_LIST_BEGIN_LOADING,
	SET_CAD_LIST_DATA,
	SET_CAD_LIST_STOP_LOADING,
} from './CADList.constants';

export const closingCustomAttributeDelete = (): CadReduxAction => ({
	type: CLOSING_CUSTOM_ATTRIBUTE_DEFINITION_DELETE,
});

export const openingCustomAttributeDefinitionDelete = (): CadReduxAction => ({
	type: OPENING_CUSTOM_ATTRIBUTE_DEFINITION_DELETE,
});

export const removingCustomAttributeDefinitionAction = (
	id: string,
	label: string,
): CadReduxAction => ({
	type: REMOVING_CUSTOM_ATTRIBUTE_DEFINITION,
	payload: {
		id,
		label,
	},
});

export const goToCADEditForm = (id: string): CadReduxAction =>
	push(`/custom-attributes/${id}/edit`, null, { type: 'GO_TO_CAD_EDIT_FORM' }) as CadReduxAction;

export const goToCADAddForm = push('/custom-attributes/add', null, { type: 'GO_TO_CAD_ADD_FORM' });

export const setCADListDataAction = (data: CustomAttributeDefinition[]): CadReduxAction => ({
	type: SET_CAD_LIST_DATA,
	payload: { value: data },
});
export const resetCADListDataAction = { type: RESET_CAD_LIST_DATA };
export const setCADListBeginLoadingAction = { type: SET_CAD_LIST_BEGIN_LOADING };
export const setCADListStopLoadingAction = { type: SET_CAD_LIST_STOP_LOADING };
export const getCustomAttributeDefinitionsAction = { type: GET_CUSTOM_ATTRIBUTE_DEFINITIONS };
export const cleanCustomAttributeDefinitionsAction = { type: CLEAN_CUSTOM_ATTRIBUTE_DEFINITIONS };
